import WeatherChatView from "./ChatWeatherItem"

export default WeatherChatView
